import { graphql } from '../../../../gql'

export const CREATE_POSTING_PLAN_MUTATION = graphql(/* GraphQL */ `
  mutation SetPostingScheduleForChannel(
    $input: SetPostingScheduleForChannelInput!
  ) {
    setPostingScheduleForChannel(input: $input) {
      ... on SetPostingScheduleForChannelResponse {
        postingSchedule {
          day
          paused
          times
        }
      }
      ... on MutationError {
        message
      }
    }
  }
`)
